/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Skip_To_Main_ContentInputs */

const en_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to main content`)
};

const es_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al contenido principal`)
};

/**
* | output |
* | --- |
* | "Skip to main content" |
*
* @param {Skip_To_Main_ContentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const skip_to_main_content = /** @type {((inputs?: Skip_To_Main_ContentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Skip_To_Main_ContentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_skip_to_main_content(inputs)
	return en_skip_to_main_content(inputs)
});